/* eslint-disable */
// @ts-nocheck
import { bynd } from './legacy-code/bynd';

export const initOldCarousel = function (carousels) {
  const carouselClass = 'carousel';
  const carouselClassSelector = '.js-carousel';
  const selectedDotClass = 'selected';
  const timerDelay = 10000;
  let i = 0;
  const l = carousels.length;
  if (!carousels) {
    return;
  }

  /*
   * @class
   */
  function Carousel(el) {
    this.el = el;
    this.id = '#' + this.el.id;
    this.init();
  }

  Carousel.prototype.init = function () {
    const me = this;
    me.currentIndex = 0;

    //do not use ":scope with chained methods as does not work in IE"
    me.scrollContainer = document.querySelector(me.id + ' div');

    if (!me.scrollContainer) {
      if (console) {
        console.log('Carousel Return');
      }
      return;
    }

    me.carouselContainer = document.querySelector(me.id + ' div ul');
    me.carouselItems = bynd.nodeListToArray(document.querySelectorAll(me.id + ' > div > ul li'));
    me.carouselLength = me.carouselItems.length;

    //setup object
    bynd.addClass(me.el, carouselClass);
    me.calculateScrollWidth();
    me.setWidth();
    me.createDots();
    me.selectDot();
    me.timer();

    window.addEventListener(
      'resize',
      () => {
        me.resizeThrottler();
      },
      false
    );
  };

  Carousel.prototype.createDots = function () {
    let i = 0;
    const me = this;
    me.ul = document.createElement('ul');
    me.addClickListener();
    me.dots = [];
    while (i < me.carouselLength) {
      me.dots[i] = document.createElement('li');
      me.dots[i].appendChild(document.createTextNode('Item ' + ( i + 1 )));
      me.ul.appendChild(me.dots[i]);
      ++i;
    }
    me.el.appendChild(me.ul);
  };

  Carousel.prototype.addClickListener = function () {
    const me = this;
    me.ul.addEventListener('click', (e) => {
      const t = e.target;
      me.scrollToTarget(t);
    });
  };

  Carousel.prototype.scrollToTarget = function (target) {
    const me = this;
    const index = me.dots.indexOf(target);
    //click on ul handler
    if (index < 0) {
      return;
    }
    me.timer();
    me.scrollToIndex(index);
  };

  Carousel.prototype.scrollToIndex = function (index) {
    const me = this;

    me.scrollContainer.scroll({
      left: Math.floor(me.scrollWidth * index),
      top: 0,
      behavior: 'smooth',
    });

    me.deselectDot();
    me.currentIndex = index;
    me.selectDot();
  };

  Carousel.prototype.calculateScrollWidth = function () {
    const me = this;
    me.scrollWidth = me.el.offsetWidth;
  };

  Carousel.prototype.setWidth = function () {
    const me = this;
    let i = 0;
    const len = Math.floor(100 / me.carouselLength);

    //set container width to items * 100%
    me.carouselContainer.style.width = me.carouselLength * 100 + '%';

    while (i < me.carouselLength) {
      me.carouselItems[i].style.width = len + '%';
      ++i;
    }
  };

  Carousel.prototype.deselectDot = function () {
    const me = this;
    bynd.removeClass(me.dots[me.currentIndex], selectedDotClass);
  };

  Carousel.prototype.selectDot = function () {
    const me = this;
    bynd.addClass(me.dots[me.currentIndex], selectedDotClass);
  };

  Carousel.prototype.resize = function () {
    const me = this;
    me.calculateScrollWidth();
    me.scrollToIndex(me.currentIndex);
  };

  Carousel.prototype.resizeThrottler = function () {
    const me = this;
    // ignore resize events as long as an actualResizeHandler execution is in the queue
    if (!me.resizeTimeout) {
      me.resizeTimeout = setTimeout(() => {
        me.resizeTimeout = null;
        me.resize();
        //will execute at a rate of 8fps
      }, 132);
    }
  };

  Carousel.prototype.timer = function () {
    const me = this;
    if (me.scrollTimer) {
      clearInterval(me.scrollTimer);
    }
    me.scrollTimer = setInterval(() => {
      let nextIndex = me.currentIndex + 1;
      if (nextIndex > me.carouselLength - 1) {
        nextIndex = 0;
      }
      me.scrollToIndex(nextIndex);
    }, timerDelay);
  };

  //init carousels after carousel class is defined;
  while (i < l) {
    new Carousel(carousels[i]);
    ++i;
  }
};

/* eslint-enable */
